module.exports = __webpack_public_path__ + "img/DSC_0283-compressor.1e472df0.jpg";